import DefaultTimelineSubcomponent from './DefaultTimelineSubcomponent';

export default DefaultTimelineSubcomponent;
